import { z } from 'zod';
import { dataConnectionQueryTypeSchema } from './data-connection-queries.js';

export const agentDataQueryRecordSchema = z.object({
  id: z.uuid(),
  agentId: z.coerce.number(),
  brandId: z.coerce.number().nullable(),
  dataConnectionQueryId: z.uuid(),
  isEnabled: z.boolean(),
  addedBy: z.coerce.number().nullable(),
  addedOn: z.coerce.date(),
  query: z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    queryType: dataConnectionQueryTypeSchema,
    dataConnectionId: z.uuid(),
    dataConnection: z.object({
      identifier: z.uuid(),
      name: z.string(),
    }),
  }),
});

export type AgentDataQueryRecord = z.infer<typeof agentDataQueryRecordSchema>;
